<template>
  <div id="contents">
    <div id="main">
      <div class="contact">
        <section>
          <main-content
            v-for="content in contentList"
            :key="content.id"
            v-bind:content="content"/>
        </section>
        <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSfFXEmKCKgfPR5SFwkKVUMNwKkErCMdeYt5AdA2qHkuC8qwCw/viewform?embedded=true" width="640" height="1069" frameborder="0" marginheight="0" marginwidth="0">読み込んでいます...</iframe>
      </div>
    </div><!--/main-->
    <sub-menu-list/>
  </div><!--/contents-->
</template>

<script>
import Content from '@/components/Content'
import SubMenuList from '@/components/SubMenuList'

export default {
  components: {
    'main-content': Content,
    'sub-menu-list': SubMenuList,
  },
  computed: {
    contentList() {
      var published = this.$store.getters.getContentListContact.filter(function(content) {
        return (content.draft == false);
      });
      return published;
      // return this.$store.getters.getContentListContact;
    }
  },
  filters: {
    resizeImage: function(value) {
      value = value.replace(/<img/g, '<img data-action="zoom" class="col-6 h-auto mb-2"');
      // value = value.replace(/(<img[^>]*>)([^<])/g, '$1<br />$2');
      value = value.replace(/(<img[^>]*>)/g, "$1<br />");
      return value;
    },
    fixParagraphText: function(value) {
      value = this.resizeImage(value);
      // value = this.clearfixParagraph(value);
      // value = this.addStyleTable(value);
      // value = this.fixURLLink(value);
      return value;
    },
  },
  head: {
    title: {
      inner: 'お問合せ',
      // innerに入力したものがタイトルになりますが、separatorとcomplementを使用すると「タイトル | 捕捉」のようになります。
      // トップページ以外でよく見ますね。不要な場合は省略可能です。
      separator: '|',
      complement: 'たちかわ演劇祭'
    },
    meta: function () {
      const title = 'お問合せ | たちかわ演劇祭'
      const description = 'たちかわ演劇祭へのお問合せ。' + 'たちかわ演劇祭は東京都立川市で毎年開催している演劇イベントです。多摩地域で活躍している劇団と市民スタッフを中心として、演劇を観る楽しさ、創る楽しさを多くの人に体験してもらう活動を続けています。'
      const keywords = 'たちかわ演劇祭 立川演劇祭 立川 たちかわ 演劇 祭 チケット 舞台 芝居 ミュージカル オペラ おすすめ たましん risuru リスル ホール'
      return [
        { name: 'description', content: description },
        { name: 'viewport', content: 'width=device-width,initial-scale=1.0,user-scalable=no' },
        { charset: 'utf-8' },
        { property: 'og:type', content: 'article' },
        { property: 'og:title', content: title },
        { property: 'og:description', content: description },
        { name: 'description', content: description },
        { name: 'keywords', content: keywords },
      ]
    },
    link: [
      // { rel: 'stylesheet', href: '外部cssファイル' },
      // { rel: 'shortcut icon', href: 'ファビコン' },
      { rel: 'stylesheet', href: 'https://cdn.jsdelivr.net/npm/zoom-vanilla.js/dist/zoom.css' },
    ],
    script: [
      // { type: 'text/javascript', src: '外部jsファイル', async: true},
      // body内に挿入したい場合は「body: true」を入れましょう
      // { type: 'text/javascript', src: '外部jsファイル', async: true, body: true},
      // { type: 'text/javascript', src: 'https://cdn.jsdelivr.net/npm/zoom-vanilla.js/dist/zoom-vanilla.min.js', async: true, body: true},
    ]
  },
};
</script>

<style>
</style>
